// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from '../../components/CRUD/AddEntity';

const AddBanks = () => {
  // Configuration for Bank inputs
  const inputs = [
    {
      name: 'bank_name_ar',
      labelKey: 'BankNameAr',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'bank_name_en',
      labelKey: 'BankNameEn',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'swift_code',
      labelKey: 'SwiftCode',
      type: 'text',
      required: true,
      defaultValue: ''
    }
  ];

  // No dropdowns for banks currently
  const dropdowns = [];

  // Build the payload for bank submission
  const buildSubmitPayload = (formValues) => {
    return {
      bank_name_en: formValues.bank_name_en.trim(),
      bank_name_ar: formValues.bank_name_ar.trim(),
      swift_code: formValues.swift_code.trim()
    };
  };

  return (
    <AddEntity
      pageTitle="AddNewBank"
      inputs={inputs}
      dropdowns={dropdowns}
      submitApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/banks`}
      buildSubmitPayload={buildSubmitPayload}
      backUrl="/settlements/Banks/"
      successMessage="BankAddedSuccessfully"
      addButtonLabel="Save"
    />
  );
};

export default AddBanks;
